export class AdminIdeaPreparingStatusDeleteRequest {
  ideaId!:string

  constructor(ideaId: string) {
    this.ideaId = ideaId
  }
}
